import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { PackagesService } from '../../../../../app/services/packages.service';

/**
 * @version $Id: content.component.ts 80922 2018-03-01 20:05:40Z thiago.h.neri $
 */
@Component({
  selector: 'hireModal',
  templateUrl: './content.template.html'
})
export class HirePackageModalComponent {

  private returnModal: boolean = false;
  private hiring: boolean = false;
  private isPortalGestao: boolean = true;

  @Input() package: any;
  @Input() lines: Array<DataPackLine>;
  @Input() totalCost: string;

  constructor(private activeModal: NgbActiveModal, private alertService: AlertService, private packagesService: PackagesService) {

  }

  private isReturn() {
    return this.returnModal;
  }

  private close() {
    this.activeModal.close();
  }

  private hire() {
    this.hiring = true;
    let payload: any = {};
    payload.lines = this.lines;
    payload.dataPackPackage = this.package;
    payload.isPortalGestao = this.isPortalGestao;
    payload.action="hirePackage";
    this.packagesService.save(payload).subscribe(
      data => {
        this.returnModal = true;
        this.hiring = false;
      },
      err => {
        this.activeModal.close();
        this.alertService.error(err.result, err);
        this.hiring = false;
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/packages/hire/content.component.ts